import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Layout from "./components/Layout";
import Dashboard from "./pages/Dashboard";
import AIChat from "./pages/AIChat";
import VBAKiller from "./pages/VBAKiller";
import DatabasePage from "./pages/DatabasePage";
import InternalTools from "./pages/InternalTools";
import ScheduleTasks from "./pages/ScheduleTasks";

function App() {
  useEffect(() => {
    document.title = "Ellerston Capital — Intelligence Platform";
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="ai-analyst" element={<AIChat />} />
            <Route path="vba-killer" element={<VBAKiller />} />
            <Route path="database" element={<DatabasePage />} />
            <Route path="internal-tools" element={<InternalTools />} />
            <Route path="schedule-tasks" element={<ScheduleTasks />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
